module.exports = __webpack_public_path__ + "media/images/p-about/flow/flow-578fd91b14e281f85971f153204d3fe9.svg";